import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref} from "vue";
import {MagnifyingGlassIcon} from '@heroicons/vue/20/solid';
import {store} from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderSearchBox',
  setup(__props) {

// @ts-ignore
const openSearch = async () => {
    store.openSearchDialog = true;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    "aria-label": "general search",
    class: "relative z-30 flex items-center px-3 py-2 mr-3 text-xs text-gray-400 transition-colors duration-200 ease-out border border-t-0 border-b-2 search-open border-zinc-100 hover:border-clay-500 border-x-0 hover:text-gray-800 hover:shadow-2xl",
    href: "#",
    onClick: _withModifiers(openSearch, ["prevent"])
  }, [
    _createVNode(_unref(MagnifyingGlassIcon), {
      "aria-hidden": "true",
      class: "inline-block w-5 h-5 mr-2 text-gray-400"
    }),
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "pr-2 search-txt text-clay-900" }, "Search...", -1))
  ]))
}
}

})